module.exports = __webpack_public_path__ + "img/solution1.fa2abceb.jpg";